import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {MessageService} from '../../../services/message.service';
import {SafeResourceUrl} from '@angular/platform-browser';
import {isArray, isString} from 'util';
import {EvoTransaction} from '../../../interfaces/evo-transaction';

@Component({
  selector: 'app-payment-gateway',
  templateUrl: './payment-gateway.component.html',
  styleUrls: ['./payment-gateway.component.scss']
})
export class PaymentGatewayComponent implements OnInit {

  @Output() closeModal = new EventEmitter();
  @Output() resultTransaction = new EventEmitter();
  public _result: boolean;

  @Input() evoHtmlBody: SafeResourceUrl;
  public watchResult: boolean;
  public haveErrors: boolean;
  public showLoader: boolean;
  public showIframe = true;
  public haveArray: boolean;
  public errors: any;
  public transaction: EvoTransaction;

  @HostListener('window:message', ['$event'])
  onmessage(event) {
    if (!event.data.type) {
      this.showLoader = true;
      this.showIframe = false;
      const responseData = JSON.parse(event.data);
      setTimeout(() => {
        if (responseData.ok === false) {
          this.watchResult = true;
          this.haveErrors = true;
          this.showLoader = false;
          this.errors = responseData.information.message;
          this.resultTransaction.emit(false);
          this._result = false;
        }
        if (responseData.ok === true) {
          this.showLoader = false;
          this.watchResult = true;
          this.haveErrors = false;
          this.transaction = responseData.information.transaction;
          this.resultTransaction.emit(true);
          this._result = true;
        }
      }, 1000);
    }
  }

  constructor(
    private messageService: MessageService,

  ) { }

  ngOnInit(): void {
  }

  checkTypeErrors() {
    if (this.checkTypeOf(this.errors) === 'array') {
      this.haveArray = true;
    }
    if (this.checkTypeOf(this.errors) === 'string') {
      this.haveArray = false;
    }
  }

  checkTypeOf(data) {
    if (isArray(data)) {
      return 'array';
    }
    if (isString(data)) {
      return 'string';
    }
  }

  onClose() {
    this.closeModal.emit();
  }

}
